import { HttpAdapter } from '../HttpAdapter';
import { basicConfig } from '../../config';

export class ValidationService {
  static postValidation = (config = {}) => {
    return HttpAdapter.post(`${basicConfig.gridFitApi}/api/info/code-validation`, config);
  };
}
